import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Order} from "../../../../objects/orders/order";
import {CanadianCurrencyCode} from "../../../../objects/currencyExchange/canadianCurrencyCode";
/**
 * Created by vlad.p on 9/14/2017.
 */

@Component({
    selector: "currency-card",
    templateUrl: "currency-card.component.html",
    moduleId: module.id.toString()
})
export class CurrencyCardComponent implements AfterViewInit {

    @Input()
    public order: Order;

    @Input()
    public title: string;

    @Input()
    public total: number;

    @Input()
    public percentFee: number;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[];

    @Output()
    public currencyChanged: EventEmitter<CanadianCurrencyCode> = new EventEmitter();

    @Input()
    public defaultCurrencyCode: CanadianCurrencyCode;

    @Input()
    public disableChanges: boolean;

    @Input()
    public showHighlight: boolean = false;

    public currentCurrencyCode: CanadianCurrencyCode = new CanadianCurrencyCode();

    public ngAfterViewInit(): void {
        setTimeout(() => {
            this.currentCurrencyCode = this.getDefaultCurrencyCode();
        });
    }

    public getDefaultCurrencyCode(): CanadianCurrencyCode {
        if (this.defaultCurrencyCode == null)
            return null;

        return this.canadianCurrencyCodes.find(x => x.Code == this.defaultCurrencyCode.Code);
    }

    public convert(selectedCode: CanadianCurrencyCode): void {
        this.currencyChanged.emit(selectedCode);
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/cards/currency-card/currency-card.component.ts